// import ElementUI from 'xl-element-ui'
import { Table, TableColumn } from 'xl-element-ui'
import './styles/index.css'
import Vant from 'vant'
// import tablePageable from './components/tablePageable/index.vue'
// import MarkedMap from './components/map/index.vue'
import panel from './components/panel/index.vue'
// import numberUnit from './components/numberUnit/index.vue'
// import numberCard from './components/numberCard/index.vue'
// import timeline from './components/timeline/timeline.vue'
// import timelineItem from './components/timeline/timelineItem.vue'
// import gantt from './components/gantt/index.vue'
// import collapse from './components/collapse/index.vue'
// import timeMark from './components/timeMark/index.vue'

// import Container from './components/container/index.vue'
// import Pagination from './components/pagination/index.vue'
// import Icon from './components/icon/index.vue'
import selectTree from './components/treeSelect/index.vue'
// import dyQuery from './components/dyQuery/index.vue'
// import tabTree from './components/tabTree/index.vue'
// import Dropdown from './components/dropdown/index.vue'
// import globalMenu from './components/globalMenu/index.vue'
// import TabCard from './components/tabCard/index.vue'
// import flow from './components/flow/index.vue'
// import flowDis from './components/flow/discribe.vue'
import lineChart from './components/line-chart/index.vue'
import barChart from './components/bar-chart/index.vue'
import pieChart from './components/pie-chart/index.vue'
import dateTimePicker from './components/dateTimePicker/index.vue'
import picker from './components/picker/index.vue'

const components = [
  {
    name: 'xlm-icon',
    component: Vant.Icon
  },
  {
    name: 'xlm-row',
    component: Vant.Row
  },
  {
    name: 'xlm-col',
    component: Vant.Col
  },
  {
    name: 'xlm-cell-group',
    component: Vant.CellGroup
  },
  {
    name: 'xlm-cell',
    component: Vant.Cell
  },
  {
    name: 'xlm-popup',
    component: Vant.Popup
  },
  {
    name: 'xlm-image',
    component: Vant.Image
  },
  {
    name: 'xlm-radio',
    component: Vant.Radio
  },
  {
    name: 'xlm-radio-group',
    component: Vant.RadioGroup
  },
  {
    name: 'xlm-switch',
    component: Vant.Switch
  },
  {
    name: 'xlm-field',
    component: Vant.Field
  },
  {
    name: 'xlm-form',
    component: Vant.Form
  },
  {
    name: 'xlm-number-keyboard',
    component: Vant.NumberKeyboard
  },
  {
    name: 'xlm-password-input',
    component: Vant.PasswordInput
  },
  {
    name: 'xlm-toast',
    component: Vant.Toast
  },
  {
    name: 'xlm-Rate',
    component: Vant.Rate
  },
  {
    name: 'xlm-calendar',
    component: Vant.Calendar
  },
  {
    name: 'xlm-cascader',
    component: Vant.Cascader
  },
  {
    name: 'xlm-uploader',
    component: Vant.Uploader
  },
  {
    name: 'xlm-checkbox',
    component: Vant.Checkbox
  },
  {
    name: 'xlm-checkbox-group',
    component: Vant.CheckboxGroup
  },
  {
    name: 'xlm-search',
    component: Vant.Search
  },
  {
    name: 'xlm-slider',
    component: Vant.Slider
  },
  {
    name: 'xlm-stepper',
    component: Vant.Stepper
  },
  {
    name: 'xlm-button',
    component: Vant.Button
  },
  {
    name: 'xlm-table',
    component: Table
  },
  {
    name: 'xlm-table-column',
    component: TableColumn
  },
  {
    name: 'xlm-action-sheet',
    component: Vant.ActionSheet
  },
  {
    name: 'xlm-dialog',
    component: Vant.Dialog
  },
  {
    name: 'xlm-dropdown-menu',
    component: Vant.DropdownMenu
  },
  {
    name: 'xlm-dropdown-item',
    component: Vant.DropdownItem
  },
  {
    name: 'xlm-loading',
    component: Vant.Loading
  },
  {
    name: 'xlm-notify',
    component: Vant.Notify
  },
  {
    name: 'xlm-overlay',
    component: Vant.Overlay
  },
  {
    name: 'xlm-pull-refresh',
    component: Vant.PullRefresh
  },
  {
    name: 'xlm-share-sheet',
    component: Vant.ShareSheet
  },
  {
    name: 'xlm-swipe-cell',
    component: Vant.SwipeCell
  },
  //   name: 'xl-dropdown',
  //   component: Dropdown
  // }, {
  //   name: 'xl-dropdown-menu',
  //   component: ElementUI.DropdownMenu
  // }, {
  //   name: 'xl-dropdown-item',
  //   component: ElementUI.DropdownItem
  // }, {
  //   name: 'xl-steps',
  //   component: ElementUI.Steps
  // }, {
  //   name: 'xl-step',
  //   component: ElementUI.Step
  // }, {
  //   name: 'xl-tooltip',
  //   component: ElementUI.Tooltip
  // }, {
  //   name: 'xl-popover',
  //   component: ElementUI.Popover
  // }, {
  //   name: 'xl-popconfirm',
  //   component: ElementUI.Popconfirm
  // }, {
  //   name: 'xl-calendar',
  //   component: ElementUI.Calendar
  // }, {
  //   name: 'xl-drawer',
  //   component: ElementUI.Drawer
  // }, {
  //   name: 'xl-carousel',
  //   component: ElementUI.Carousel
  // }, {
  //   name: 'xl-carousel-item',
  //   component: ElementUI.CarouselItem
  // }, {
  //   name: 'xl-collapse-transition',
  //   component: ElementUI.CollapseTransition
  // },
  {
    name: 'xlm-datetime-picker',
    component: dateTimePicker
  }, {
    name: 'xlm-picker',
    component: picker
  }, {
    name: 'xlm-bar-chart',
    component: barChart
  }, {
    name: 'xlm-line-chart',
    component: lineChart
  }, {
    name: 'xlm-pie-chart',
    component: pieChart
  }, {
    name: 'xlm-select-tree',
    component: selectTree
  },
]

const install = function (Vue) {
  components.forEach(item => {
    Vue.component(item.name, item.component)
  })
}

export default {
  install
}

// export const XlTablePageable = tablePageable
// export const XlMap = MarkedMap
export const XlmPanel = panel
// export const XlNumberUnit = numberUnit
// export const XlNumberCard = numberCard
// export const XlTimeline = timeline
// export const XlTimelineItem = timelineItem
// export const XlGantt = gantt
// export const XlFlow = flow
// export const XlFlowDis = flowDis
// export const XlTimeMark = timeMark
// export const xlmSelectTree = selectTree
// export const XlDyQuery = dyQuery
// export const XlTabTree = tabTree
// export const XlGlobalMenu = globalMenu
// export const XlTabCard = TabCard
// export const XlCollapse = collapse

// 可以直接使用的原生element组件

// export const Loading = ElementUI.Loading.service
// export const MessageBox = ElementUI.MessageBox
// export const Alert = ElementUI.MessageBox.alert
// export const Confirm = ElementUI.MessageBox.confirm
// export const Prompt = ElementUI.MessageBox.prompt
// export const Notify = ElementUI.Notification
// export const Message = ElementUI.Message
